import React from 'react';
import { Bubbles } from '../style';
import { Logo } from './index';

const Header = () => {
  return (
    <>
      <Logo />
      <Bubbles />
    </>
  );
};

export default Header;
